import axios from "axios";
import { API_BASE_URL } from "./config";

const api = axios.create({
    baseURL: `${API_BASE_URL}/api/videos`,
    withCredentials: true,
});

export const getRandomVideos = async () => {
    const response = await api.get("/random");
    return response.data;
};

// Real paginated home feed - replaces relying on getRandomVideos() for the
// main feed. sort: "recent" (default) | "popular" | "oldest"
export const getVideoFeed = async (page = 1, limit = 12, sort = "recent") => {
    const response = await api.get("/feed", { params: { page, limit, sort } });
    return response.data; // { videos, page, limit, total, hasMore }
};

export const getTrendingVideos = async () => {
    const response = await api.get("/trending");
    return response.data;
};

// Paginated trending, for "Load More" on the Trending page.
export const getTrendingVideosPaginated = async (page = 1, limit = 20) => {
    const response = await api.get("/trending", { params: { page, limit } });
    return response.data; // { videos, page, limit, total, hasMore }
};

export const getVideoByTags = async () => {
    return await api.get("/tags");
};

export const getSubscribedVideos = async () => {
    return await api.get("/subscribed");
};

export const getVideosOfUser = async (id) => {
    return await api.get(`/${id}`);
};

// Paginated, server-side search by title
export const getVideosByTitle = async (searchText, page = 1, limit = 12, sort) => {
    const response = await api.get("/search", {
        params: { search_query: searchText, page, limit, sort },
    });
    return response.data; // { videos, page, limit, total, hasMore }
};

// Related videos for the "Recommended" sidebar on the watch page
export const getRelatedVideos = async (videoId, limit = 12) => {
    const response = await api.get(`/related/${videoId}`, { params: { limit } });
    return response.data; // array of videos
};

export const getVideoById = async (videoId) => {
    return await api.get(`/find/${videoId}`);
};

export const viewVideo = async (id) => {
    const response = await api.put(`/view/${id}`);
    return response;
};

export const newVideo = async (video) => {
    return await api.post("/", video);
};

export const editVideo = async (vId, updateData) => {
    return await api.put(`/${vId}`, updateData);
};

export const deleteVideo = async (vId) => {
    return await api.delete(`/delete/${vId}`);
};
